import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { StoryState } from './state/story.state';
import { StoryLabelsState } from './state/labels/story.labels.state';
import { LabelComponent } from './components/labels/label/label.component';
import { LabelsComponent } from './components/labels/labels/labels.component';
import { SharedModule } from '../shared/shared.module';
import { StoryChaptersState } from './state/chapters/story.chapters.state';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      StoryState,
      StoryChaptersState,
      StoryLabelsState
    ]),
    CommonModule,
    SharedModule,
    FontAwesomeModule
  ],
  declarations: [LabelComponent, LabelsComponent],
  exports: [LabelComponent, LabelsComponent]
})
export class StoryModule { }
